/*
 * @param {String} fullName A space-delimited full name
 * @returns {String} The Initials given the full name
 */
import { undefinedNamePlaceholder } from '../config/placeholderConstants';

export default function getInitials(fullName) {
  if (!fullName || typeof fullName !== 'string') return undefinedNamePlaceholder;
  const split = fullName.split(' ');
  switch (split.length) {
    case 0: return undefinedNamePlaceholder;
    case 1: return split[0].charAt(0) || undefinedNamePlaceholder;
    default: {
      const firstNameInitial = split[0].charAt(0);
      const lastNameInitial = split[split.length - 1].charAt(0);
      if (!firstNameInitial && !lastNameInitial) return undefinedNamePlaceholder;
      return firstNameInitial + lastNameInitial;
    }
  }
}
